/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./Navbar.css";
import CMS from "../cms.json";

const navbar = CMS.navbar || {};
const socials = CMS.socials || {};
const navLinks = navbar.links || [
  { text: "Shows", href: "/home#shows" },
  { text: "Merch", href: "/merch" },
  { text: "Booking", href: "/home#booking" },
];
const logoSrc = navbar.logoSrc || "/images/logos/logohorizontal.png";

const socialIcons = socials.icons || {};
const SOCIAL_ICONS = [
  { key: "tiktok",    src: socialIcons.tiktok    || "https://img.icons8.com/?size=100&id=soupkpLfTkZi&format=png&color=FFFFFF", alt: "TikTok" },
  { key: "instagram", src: socialIcons.instagram || "https://img.icons8.com/?size=100&id=85154&format=png&color=FFFFFF",        alt: "Instagram" },
  { key: "youtube",   src: socialIcons.youtube   || "https://img.icons8.com/?size=100&id=85064&format=png&color=FFFFFF",        alt: "YouTube" },
];

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const isHomePage = window.location.pathname === "/" || window.location.pathname === "/home";
  const [isVisible, setIsVisible] = useState(!isHomePage);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "unset";
  }, [isMenuOpen]);

  useEffect(() => {
    if (!isHomePage) return;
    const onScroll = () => setIsVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [isHomePage]);

  return (
    <div className={`top-navbar ${isVisible ? "navbar-visible" : "navbar-hidden"}`}>
      <nav className="navbar">
        <div className="nav-section social-links">
          {SOCIAL_ICONS.filter(s => socials[s.key]).map(s => (
            <a key={s.key} href={socials[s.key]} className="social-link">
              <img src={s.src} alt={s.alt} />
            </a>
          ))}
        </div>
        <div className="nav-section logo">
          <a href="/home">
            <img src={logoSrc} alt="The Creaks Logo" className="nav-logo" />
          </a>
        </div>
        <div className="nav-section menu-links">
          {navLinks.map((link, i) => (
            <a key={i} href={link.href} className="menu-link">{link.text}</a>
          ))}
        </div>
      </nav>

      <button
        className={`hamburger-menu ${isMenuOpen ? "open" : ""}`}
        style={{ position: "fixed", top: "1.5rem", right: "1.5rem" }}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <span></span><span></span><span></span>
      </button>

      {isMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setIsMenuOpen(false)}>
          <div className="mobile-menu-content" onClick={e => e.stopPropagation()}>
            <a href="/home#">
              <img src={logoSrc} alt="The Creaks Logo" className="mobile-menu-logo" />
            </a>
            <div className="mobile-nav-links">
              {navLinks.map((link, i) => (
                <a key={i} href={link.href} className="mobile-menu-link" onClick={() => setIsMenuOpen(false)}>
                  {link.text}
                </a>
              ))}
            </div>
            <div className="mobile-social-links">
              {SOCIAL_ICONS.filter(s => socials[s.key]).map(s => (
                <a key={s.key} href={socials[s.key]} className="social-link">
                  <img src={s.src} alt={s.alt} />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;
